module.exports = __webpack_public_path__ + "img/sampleGraph1.3e609fdb.png";